var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiTresBien(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 24C2 29.9674 4.37053 35.6903 8.5901 39.9099C12.8097 44.1295 18.5326 46.5 24.5 46.5C30.4674 46.5 36.1903 44.1295 40.4099 39.9099C44.6295 35.6903 47 29.9674 47 24C47 18.0326 44.6295 12.3097 40.4099 8.0901C36.1903 3.87053 30.4674 1.5 24.5 1.5C18.5326 1.5 12.8097 3.87053 8.5901 8.0901C4.37053 12.3097 2 18.0326 2 24V24Z",
    stroke: "#24B083",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.768 28.5C11.528 28.5 11.2916 28.5576 11.0785 28.668C10.8654 28.7783 10.6819 28.9381 10.5434 29.1341C10.4049 29.33 10.3154 29.5563 10.2824 29.794C10.2494 30.0317 10.274 30.2738 10.354 30.5C11.3863 33.4272 13.3014 35.962 15.835 37.755C18.3686 39.5481 21.3961 40.5109 24.5 40.5109C27.6039 40.5109 30.6313 39.5481 33.165 37.755C35.6986 35.962 37.6136 33.4272 38.646 30.5C38.726 30.2738 38.7505 30.0317 38.7175 29.794C38.6846 29.5563 38.5951 29.33 38.4566 29.1341C38.318 28.9381 38.1345 28.7783 37.9215 28.668C37.7084 28.5576 37.4719 28.5 37.232 28.5H11.768Z",
    stroke: "#24B083",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 15.75C33.6483 15.75 33.7933 15.794 33.9167 15.8764C34.04 15.9588 34.1361 16.0759 34.1929 16.213C34.2497 16.35 34.2645 16.5008 34.2356 16.6463C34.2066 16.7918 34.1352 16.9254 34.0303 17.0303C33.9254 17.1352 33.7918 17.2066 33.6463 17.2356C33.5008 17.2645 33.35 17.2497 33.213 17.1929C33.0759 17.1361 32.9588 17.04 32.8764 16.9167C32.794 16.7933 32.75 16.6483 32.75 16.5C32.75 16.3011 32.829 16.1103 32.9697 15.9697C33.1103 15.829 33.3011 15.75 33.5 15.75Z",
    stroke: "#24B083",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.75C15.6483 15.75 15.7933 15.794 15.9167 15.8764C16.04 15.9588 16.1361 16.0759 16.1929 16.213C16.2497 16.35 16.2645 16.5008 16.2356 16.6463C16.2067 16.7918 16.1352 16.9254 16.0303 17.0303C15.9254 17.1352 15.7918 17.2066 15.6463 17.2356C15.5008 17.2645 15.35 17.2497 15.213 17.1929C15.0759 17.1361 14.9588 17.04 14.8764 16.9167C14.794 16.7933 14.75 16.6483 14.75 16.5C14.75 16.3011 14.829 16.1103 14.9697 15.9697C15.1103 15.829 15.3011 15.75 15.5 15.75Z",
    stroke: "#24B083",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiTresBien);
export default __webpack_public_path__ + "static/media/emoji-tres-bien.1e96d16ebfec092a3e8b7eab06570895.svg";
export { ForwardRef as ReactComponent };